<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Coil Options</label>
  <span class="spacer"></span>
  <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (unionsOnCoilSelection) {
          <span>
            <label class="halfWidthInputLabel">Unions on Coil:</label>
            <select class="halfWidthInputField" #coilUnionsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(unionsOnCoilSelection.Name)"
              (change)="selectedValueChanged(unionsOnCoilSelection.Name, coilUnionsInput.value)"
              [value]="unionsOnCoilSelection.Value.toString()">
              @for (allowable of unionsOnCoilSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="unionsOnCoilSelection.Value && unionsOnCoilSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (autoAirVentsSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(autoAirVentsSelection.Name)"
            for="autoVentsInput" class="halfWidthInputLabel">Auto Air Vents:</label>
            <input type="checkbox" class="checkboxInput" id="autoVentsInput"
              #autoVentsInput [checked]="'true' === autoAirVentsSelection.Value"
              (change)="selectedValueChanged(autoAirVentsSelection.Name, autoVentsInput.checked.toString())">
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (coilConstructionSelection) {
          <span>
            <label class="halfWidthInputLabel">Coil Construction:</label>
            <select class="halfWidthInputField" #coilConstructionInput
              [class.invalidConfigurationSelection]="isInvalidSelection(coilConstructionSelection.Name)"
              (change)="selectedValueChanged(coilConstructionSelection.Name, coilConstructionInput.value)"
              [value]="coilConstructionSelection.Value.toString()">
              @for (allowable of coilConstructionSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="coilConstructionSelection.Value && coilConstructionSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (drainValveSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(drainValveSelection.Name)"
            for="drainValveInput" class="halfWidthInputLabel">Drain Valve:</label>
            <input type="checkbox" class="checkboxInput" id="drainValveInput"
              #drainValveInput [checked]="'true' === drainValveSelection.Value"
              (change)="selectedValueChanged(drainValveSelection.Name, drainValveInput.checked.toString())">
          </span>
        }
      </span>
    </div>
    <div class="configurationDetailRow">
      <span class="fullWidthConfigurationInput">
        @if (testPressureSelection) {
          <span>
            <label class="halfWidthInputLabel">Test Pressure:</label>
            <select class="halfWidthInputField" #testPressureInput
              [class.invalidConfigurationSelection]="isInvalidSelection(testPressureSelection.Name)"
              (change)="selectedValueChanged(testPressureSelection.Name, testPressureInput.value)"
              [value]="testPressureSelection.Value.toString()">
              @for (allowable of testPressureSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="testPressureSelection.Value && testPressureSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </span>
      <span class="fullWidthConfigurationInput">
        @if (preHeatSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(preHeatSelection.Name)"
            for="preHeatInput" class="halfWidthInputLabel">Pre Heat:</label>
            <input type="checkbox" class="checkboxInput" id="preHeatInput" #preHeatInput
              [checked]="'true' === preHeatSelection.Value"
              (change)="selectedValueChanged(preHeatSelection.Name, preHeatInput.checked.toString())">
          </span>
        }
      </span>
    </div>
  </div>
}
